export interface UserSetting {
    id:string;
    [key:string]:string;
}


export const UserSettingUtil = {
    COLLECTION: 'UserSetting',
    create: (settings:Partial<UserSetting>)=>{

    },
}